import React from 'react';
import { WebpageContent } from '../elements/WebpageContent';
import { TextContent } from '../elements/TextContent';
import { LinkContent } from '../elements/LinkContent';

export const Invalid = () => {
  return (
    <WebpageContent>
      {
        <div>
          <TextContent
            label={
              <>
                Looks like you&apos;ve wandered off to an invalid address, go{' '}
                <LinkContent label={'home'} href={'/'} tailwindCss={'underline'} />
              </>
            }
            tailwindCss={'text-xs lg:text-base font-extra-thin'}
          />
          <br />
          <TextContent label={'404'} tailwindCss={'text-2xl lg:text-5xl font-normal'} />
        </div>
      }
    </WebpageContent>
  );
};
